// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderRequestBase {
    static getAttributeTypeMap() {
        return PharmacyCardFinderRequestBase.attributeTypeMap;
    }
}
PharmacyCardFinderRequestBase.discriminator = undefined;
PharmacyCardFinderRequestBase.additionalProperties = false;
PharmacyCardFinderRequestBase.attributeTypeMap = [
    {
        "name": "daysSupply",
        "baseName": "daysSupply",
        "type": "string"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "PharmacyCardFinderPatientRequest"
    },
    {
        "name": "pharmacyNcpDpId",
        "baseName": "pharmacyNcpDpId",
        "type": "string"
    },
    {
        "name": "pharmacyNpi",
        "baseName": "pharmacyNpi",
        "type": "string"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "PharmacyCardFinderPrescriber"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "string"
    },
    {
        "name": "clientId1",
        "baseName": "clientId1",
        "type": "string"
    },
    {
        "name": "clientId2",
        "baseName": "clientId2",
        "type": "string"
    },
    {
        "name": "clientId3",
        "baseName": "clientId3",
        "type": "string"
    },
    {
        "name": "clientId4",
        "baseName": "clientId4",
        "type": "string"
    },
    {
        "name": "clientId5",
        "baseName": "clientId5",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderRequestBase.js.map